import { header as AT } from './AT';
import { header as CZ } from './CZ';
import { header as HR } from './HR';
import { header as HU } from './HU';
import { header as RO } from './RO';
import { header as SK } from './SK';
import { header as RS } from './RS';

export const featureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
